export default __webpack_public_path__ + "static/media/clusterconfiguration_openapi.5bbea849.yaml";